define([
    'app/controllers/Controller',
    'rv!app/views/shoppingcart',
    'rv!app/views/warningDeliveryTime',
    'app/models/cartItem',
], function (Controller, shoppingcartTemplate, warningDeliveryTimeTemplate, CartItem) {
    function shoppingCartController() {
        var checkout = $('#checkout');
        var Ractive = Controller.ractive;
        var ractiveShoppingCart = false;

        function init() {
            partyking.common.models.shoppingcart.unMarkOrderSent();

            setupShoppingCart();
            //setupWarningDeliveryTime();

            if (partyking.common.models.shoppingcart.serverValidate) {
                validateOrderItems();
            }
        }

        function validateOrderItems() {
            partyking.common.models.shoppingcart.isPerformingCheckoutValidation = true;
            if (partyking.common.models.shoppingcart.ignoreStock) return true;

            var order = partyking.common.models.shoppingcart.toOrder();

            order.serverValidate(function (data) {
                if (data.data && data.data.items) {
                    var items = data.data.items;

                    partyking.common.models.shoppingcart.items = _.mapObject(
                        partyking.common.models.shoppingcart.items,
                        function (value, key) {
                            var output = value;

                            if (items[key] && items[key].type == 'product') {
                                output.data = _.extend(output.data, items[key].data);
                                output.update();
                            }

                            return output;
                        }
                    );

                    partyking.common.models.shoppingcart.update();
                    partyking.common.models.shoppingcart.isPerformingCheckoutValidation = false;
                }
            });
        }

        function setupWarningDeliveryTime() {
            var warningDeliveryTime = new Ractive({
                el: '#warning-delivery-time',
                template: warningDeliveryTimeTemplate || '',
                magic: true,
                data: partyking.common.models.shoppingcart,
            });
        }

        function setupShoppingCart() {
            ractiveShoppingCart = new Ractive({
                el: '#shoppingcart',
                template: shoppingcartTemplate,
                magic: true,
                data: partyking.common.models.shoppingcart,
                onchange: function () {
                    if (partyking.common.models.shoppingcart.productsInCart) {
                        checkout.removeClass('empty').addClass('active');
                    } else {
                        checkout.removeClass('active').addClass('empty');
                        $('#checkout-payment-and-delivery').hide();
                    }
                },
            });

            ractiveShoppingCart.on('decreaseQuantity', function (event) {
                try {
                    partyking.common.models.shoppingcart.removeItem(event.context);
                } catch (e) {
                    partyking.common.log.error('USER ERROR: decreaseQuantity shoppingcart', e);
                }
            });

            ractiveShoppingCart.on('increaseQuantity', function (event, data) {
                try {
                    partyking.common.models.shoppingcart.addItem(event.context);
                } catch (e) {
                    partyking.common.log.error('USER ERROR: increaseQuantity shoppingcart', e);
                }
            });

            ractiveShoppingCart.on('deselectQuantity', function (event) {
                var cartItem = event.context;
                var key = cartItem.key;
                cartItem.quantity = parseInt(cartItem.quantity) > 0 ? parseInt(cartItem.quantity) : 1;
                cartItem.update();
                partyking.common.models.shoppingcart.update();
                partyking.common.trigger('productQuantityChanged', cartItem);
            });

            ractiveShoppingCart.on('keypressQuantity', function (event) {
                var domEvent = event.original;
                var node = event.node;
                if (domEvent.which == 13) {
                    node.blur();
                }
            });

            ractiveShoppingCart.on('showDiscountField', function () {
                partyking.common.models.shoppingcart.showDiscountField = true;
            });

            ractiveShoppingCart.on('addDiscountCode', function (event, code) {
                var domEvent = event.original;
                if (domEvent.which == 13 || domEvent.which == 1) {
                    partyking.common.models.shoppingcart.addDiscountCode(code, function (success) {
                        if (success) {
                            $(event.node).parent().find('input').val('');
                        }
                    });
                }
            });

            ractiveShoppingCart.on('removeDiscountCode', function (event) {
                partyking.common.models.shoppingcart.removeDiscountCode();
            });

            ractiveShoppingCart.on('removeGiftCard', function (event) {
                partyking.common.models.shoppingcart.removeGiftCard();
            });

            ractiveShoppingCart.on('keypressQuantity', function (event) {
                var domEvent = event.original;
                var node = event.node;
                if (domEvent.which == 13) {
                    node.blur();
                }
            });

            ractiveShoppingCart.on('cartToHash', function (event) {
                try {
                    var hash = partyking.common.models.shoppingcart.createHashFromCart();
                    partyking.common.models.shoppingcart.showHash = true;
                } catch (e) {
                    partyking.common.log.error('USER ERROR: createHashFromCart', e);
                }
            });

            ractiveShoppingCart.on('activateFreeFun', function (event) {
                const freeFunElement = document.getElementById('free-fun');

                const { productId, urlName } = event.node.dataset;

                const alreadyHasFreeStuff = partyking.common.models.shoppingcart.isProductInCart(urlName);

                if (alreadyHasFreeStuff) {
                    const freeStuff = partyking.common.models.shoppingcart.getProduct(urlName);
                    try {
                        partyking.common.models.shoppingcart.removeItem(freeStuff);
                    } catch (e) {
                        partyking.common.log.error('USER ERROR: remove free fun shoppingcart', e);
                    }
                    freeFunElement.classList.remove('adding', 'added');
                } else {
                    freeFunElement.classList.add('adding');
                    partyking.common.helpers.getProductById(productId).then((productObject) => {
                        setTimeout(() => {
                            const article = productObject.articles[0];

                            const freeFunImageElement = document.getElementById('free-fun-img');
                            const imgName = article.image_name;
                            const productImage = partyking.common.helpers.productImage(imgName, 160);
                            if (freeFunImageElement.src !== productImage) {
                                freeFunImageElement.src = productImage;
                            }
                            const articleObject = Object.assign({}, article);
                            const item = new CartItem(articleObject);

                            const fireConfetti = (ratio, options) => {
                                if (confetti !== undefined && confetti) {
                                    const defaultCount = 50;
                                    const newCount = Math.floor(defaultCount * ratio);
                                    confetti(
                                        Object.assign({}, options, {
                                            particleCount: newCount,
                                        })
                                    );
                                }
                            };

                            const triggerSuperConfetti = (x, y) => {
                                fireConfetti(0.25, {
                                    spread: 26,
                                    startVelocity: 55,
                                    origin: { x: x, y: y },
                                });

                                fireConfetti(0.2, {
                                    spread: 60,
                                    origin: { x: x, y: y },
                                });

                                fireConfetti(0.35, {
                                    spread: 100,
                                    decay: 0.91,
                                    scalar: 0.8,
                                    origin: { x: x, y: y },
                                });

                                fireConfetti(0.1, {
                                    spread: 120,
                                    startVelocity: 25,
                                    decay: 0.92,
                                    scalar: 1.2,
                                    origin: { x: x, y: y },
                                });

                                fireConfetti(0.1, {
                                    spread: 120,
                                    startVelocity: 45,
                                    origin: { x: x, y: y },
                                });
                            };

                            const screenWidth = window.innerWidth;
                            const screenHeight = window.innerHeight;
                            const x = event.x / screenWidth;
                            const y = event.y / screenHeight;
                            triggerSuperConfetti();

                            partyking.common.models.shoppingcart.addItem(item, 1, 'free-fun-banner');
                            freeFunElement.classList.add('added');
                        }, 300);
                    });
                }
            });

            partyking.common.trigger('checkoutPageLoaded', partyking.common.models.shoppingcart);
        }

        init();
    }

    return shoppingCartController;
});
